/*
 * Module for the Membership section of Account Overview
*/

rs.module("ui/content/account/overview/membership",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            // Update the membership detail based on the selected member account
            $.js(jsSelectors.memberSelect, { required: false }).change(function () {
                $.get(
                    backendUrls.getMembershipDetail,
                    {
                        accountPartyKey: $(this).val()
                    })
                    .done(function (html) {
                        $.js(jsSelectors.memberDetail).html(html);
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);